<template>
  <e-modal
    :visible="show"
    title="查看视频"
    :width="800"
    :footer="false"
    :onlyBody="true"
    @close="onClose"
    @ok="onOk"
  >
    <div class="media-box" v-if="media">
      <video :src="media" controls></video>
    </div>
  </e-modal>
</template>
<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  components: {},
  setup () {
    const show = ref(false)
    const media = ref('')
    const style = ref({})

    const onClose = () => {
      media.value = ''
      style.value = {}
      show.value = false
    }

    const onOk = e => {
      console.log(e)
    }

    return {
      show,
      media,
      style,
      onClose,
      onOk
    }
  },

  data () {
    return {
      width: 0,
      height: 0
    }
  },

  methods: {
    open (media) {
      this.media = media
      this.show = true
    },
    onResizeFun (e) {
      this.style = {
        width: e.w + 'px',
        height: e.h + 'px',
        left: e.l + 'px',
        top: e.t + 'px'
      }
    }
  }
})
</script>

<style lang="less" scoped>
.media-box {
  width: 100%;
  height: 500px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  video {
    width: 100%;
    height: 100%;
  }
}
</style>
